export const selectStringFilter = (input, option) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase());